import { Fancybox } from "@fancyapps/ui";

export default function initializeFancybox() {
    new BlockFancybox();
}

class BlockFancybox {
    constructor() {
        this.init();
    }

    init() {
        Fancybox.bind('[data-fancybox]', {
        });
    }
}